import type { WorkspaceContextObserved } from './types/context.js';

/** Bridge notification method each agent run publishes for its workspace. */
export const WORKSPACE_CONTEXT_OBSERVED = 'workspace.contextObserved';

/**
 * Validate a `workspace.contextObserved` payload. Throws on a malformed frame
 * rather than delivering a partial one.
 */
export function parseWorkspaceContextObserved(
  value: unknown,
  path: string
): WorkspaceContextObserved {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    throw new Error(`${path} must be an object`);
  }
  const candidate = value as Record<string, unknown>;
  if (typeof candidate.workspace_id !== 'string' || candidate.workspace_id === '') {
    throw new Error(`${path}.workspace_id must be a non-empty string`);
  }
  if (typeof candidate.fingerprint !== 'string' || candidate.fingerprint === '') {
    throw new Error(`${path}.fingerprint must be a non-empty string`);
  }
  return { workspace_id: candidate.workspace_id, fingerprint: candidate.fingerprint };
}
